import type SVGType from 'types/svg.types';

const FileSearchIcon: SVGType = (props) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.0007 6.3335L23.0007 12.3335H18.334C17.5976 12.3335 17.0007 11.7365 17.0007 11.0002V6.3335ZM17.0007 6.3335H9.00065C7.52789 6.3335 6.33398 7.5274 6.33398 9.00016V23.0002C6.33398 24.4729 7.52789 25.6668 9.00065 25.6668H13.6673M22.8634 22.8629L25.6673 25.6668M20.3144 23.6276C22.1445 23.6276 23.6281 22.144 23.6281 20.3139C23.6281 18.4838 22.1445 17.0002 20.3144 17.0002C18.4843 17.0002 17.0007 18.4838 17.0007 20.3139C17.0007 22.144 18.4843 23.6276 20.3144 23.6276Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export default FileSearchIcon;
